import React, { useEffect, useContext, useState } from 'react';

import { ColumnContent, ColumnContentLarge, ColumnContentLargeTitle, ColumnContentSmall, ColumnContentSmallTitle } from 'styles/ColumnContent';
import { Text } from 'styles/Layout';
import { Container } from 'styles';
import LayoutContext from 'context/layout';
import Breadcrumb from 'components/layout/breadcrumb/Breadcrumb';
import DoubtForm from 'components/doubt-form/doubt-form/DoubtForm';
import DoubtFeedbackImage from 'components/doubt-form/doubt-feedback-image/DoubtFeedbackImage';

const DoubtFormPage = () => {
    const { setState } = useContext(LayoutContext);
    const [showFeedback, setShowFeedback] = useState(false);

    useEffect(() => {
		setState({ displaySearch: true, isHome: false });
	}, []);

    const formSent = () => {
        setShowFeedback(true);
    }

	return (
		<>
            <Breadcrumb currentPageName="Solicitações" />

            <Container>
                <ColumnContent>
                    {showFeedback ? (
                        <>
                            <ColumnContentSmall>
                                <DoubtFeedbackImage />
                            </ColumnContentSmall>
                        </>
                    ) : (
                        <ColumnContentSmall style={{padding: '2.5rem 1.5rem', background: '#F6F6F6', marginBottom: '1.5rem'}}>
                            <ColumnContentSmallTitle>Vamos te ajudar!</ColumnContentSmallTitle>
                            <Text>Se você não encontrou nenhum conteúdo para te ajudar, preencha o formulário e nos envie sua dúvida ou solicitação. Te responderemos o mais breve possível!</Text>
                        </ColumnContentSmall>
                    )}

                    <ColumnContentLarge>
                        {showFeedback ? (
                            <>
                                <ColumnContentLargeTitle>Recebemos sua mensagem!</ColumnContentLargeTitle>
                                <Text style={{marginBottom: '3rem'}}>Vamos te responder em até 24h úteis.</Text>
                            </>
                        ) : (
                            <>
                                <ColumnContentLargeTitle>Envie sua dúvida ou solicitação</ColumnContentLargeTitle>
                                <DoubtForm onConclude={formSent} />
                            </>
                        )}
                    </ColumnContentLarge>
                </ColumnContent>
            </Container>
		</>
	);
};

export default DoubtFormPage;